import React from 'react';
import get from 'lodash/get';
import { Url } from '@wix/da-url';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '../../../biLogger';
import { ResourceType } from '../../../types/resource';
import ActionBarButton from '../../_partials/ActionBarButton';
import { useFlag } from '../../../redux/flags/hooks';
export var OrderCommissionButton = function (_a) {
    var _b, _c, _d, _e, _f;
    var deviation = _a.deviation, onClick = _a.onClick, showPrice = _a.showPrice, className = _a.className;
    var t = useTranslation().t;
    var newCheckout = useFlag('new_checkout');
    var isOpen = (_c = (_b = deviation.commission) === null || _b === void 0 ? void 0 : _b.isActive) !== null && _c !== void 0 ? _c : false;
    var clickHandler = function () { return onClick(deviation); };
    var dollarsCost = (_d = deviation.commission) === null || _d === void 0 ? void 0 : _d.dollarsCost;
    var checkoutLink = ((_e = deviation.commission) === null || _e === void 0 ? void 0 : _e.subproductId) ? Url.checkoutLink((_f = deviation.commission) === null || _f === void 0 ? void 0 : _f.subproductId)
        : undefined;
    return (React.createElement(ActionBarButton, { view: "b18", isDisabled: !isOpen, className: className, onClick: newCheckout ? undefined : clickHandler, href: newCheckout ? checkoutLink : undefined, biData: {
            evid: BiEventType.PROFILE_ORDER_COMMISSION,
            typeid: ResourceType.COMMISSION,
            itemid: get(deviation, 'commission.commissionId'),
            points: get(deviation, 'commission.pointsCost'),
            creatorid: get(deviation, 'author.useridUuid'),
        } },
        t(isOpen ? 'actionbar.orderCommission' : 'actionbar.closedCommission'),
        showPrice && " $" + dollarsCost));
};
OrderCommissionButton.displayName = 'OrderCommissionButton';
export default OrderCommissionButton;
//# sourceMappingURL=OrderCommissionButton.js.map